export enum userRolesTypes {
    FETCH_USER_ROLES_REQUEST = 'FETCH_USER_ROLES_REQUEST',
    EDIT_USER_ADMIN_REQUEST = 'EDIT_USER_ADMIN_REQUEST',
    EDIT_USER_BLOCK_REQUEST = 'EDIT_USER_BLOCK_REQUEST',
    SET_USER_ROLES = 'SET_USER_ROLES',
    EDIT_USER_ROLES = 'EDIT_USER_ROLES',
    REMOVE_USER_ROLE = 'REMOVE_USER_ROLE',
    FETCH_ADDITIONAL_REQUEST = 'FETCH_ADDITIONAL_REQUEST',
}
